import { createContext } from 'react';
import { FilterValue, RelationalServerKey, ServerKey } from 'components/filter/types';
import Fuse from 'fuse.js';
import { FilterCacheKey } from 'types/filter-cache-key';

import FuseResult = Fuse.FuseResult;

type FilterSearchResource =
    | 'contact'
    | 'company'
    | 'transaction'
    | 'member'
    | 'donorsearch'
    | 'pledge'
    | 'campaign'
    | 'ticket'
    | 'plan'
    | 'tableColumn';

interface FilterSearchKey {
    serverKey: ServerKey;
    scopedServerKey: string;
    label: string;
    resource: FilterSearchResource;
}

interface IFilterContext {
    resource: FilterCacheKey;
    cacheKey: FilterCacheKey;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    nodeId?: string;
    readOnly?: boolean;
    strategyType?: ServerKey;
    setSelectedFilter: (key?: ServerKey) => void;
    relationalServerKey?: RelationalServerKey;
    setRelationalServerKey: (key?: RelationalServerKey) => void;
    search: string;
    searchInstance: Fuse<FilterSearchKey>;
    searchItems: FuseResult<FilterSearchKey>[];
    readOnlyFilter?: FilterValue;
    isLegacy?: boolean;
    setIsLegacy: (isLegacy: boolean) => void;
    clear: () => void;
    forceRender?: () => void;
}

const FilterContext = createContext<IFilterContext>({
    resource: 'contacts',
    cacheKey: 'contacts',
    isOpen: false,
    readOnly: false,
    search: '',
    searchInstance: new Fuse<FilterSearchKey>([]),
    searchItems: [],
    setIsOpen: () => {},
    setSelectedFilter: () => {},
    setRelationalServerKey: () => {},
    setIsLegacy: () => {},
    clear: () => {},
});

export { FilterContext };
export type { IFilterContext, FilterSearchKey, FilterSearchResource };
